import { styled } from "@mui/material/styles";
import { Box, Paper, Typography } from "@mui/material";

export const PageHead = styled(Box)({
  display: "flex",
  alignItems: "flex-start",
  gap: 16,
  marginBottom: 20,
});

export const RuleCard = styled(Paper)(({ theme }) => ({
  display: "flex",
  alignItems: "flex-start",
  gap: 16,
  padding: "16px 18px",
  marginBottom: 12,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: 8,
}));

export const CardLabel = styled(Typography)(({ theme }) => ({
  fontSize: 11,
  fontWeight: 600,
  letterSpacing: 0.6,
  textTransform: "uppercase",
  color: theme.palette.text.secondary,
  marginBottom: 7,
}));

export const EmptyState = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  padding: "96px 24px",
});

export const EmptyRing = styled(Box)(({ theme }) => ({
  width: 72,
  height: 72,
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginBottom: 18,
  background: `${theme.palette.primary.main}1f`,
  color: theme.palette.primary.dark,
}));

export const MatchPreview = styled(Box)(({ theme }) => ({
  marginTop: 14,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: 8,
  background: theme.palette.background.paper,
  padding: "12px 14px",
}));

export const ConditionBlock = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: 10,
  background: theme.palette.background.default,
  padding: "14px 16px",
}));

export const BlockTag = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: 7,
  fontSize: 12,
  fontWeight: 600,
  color: theme.palette.primary.dark,
  marginBottom: 12,
}));

export const BlockIndex = styled(Box)(({ theme }) => ({
  width: 19,
  height: 19,
  borderRadius: "50%",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: 11,
  background: `${theme.palette.primary.main}2e`,
  color: theme.palette.primary.dark,
}));

// AND sits inside a block; OR separates blocks. Different colours on purpose —
// the two levels must not read as the same thing.
export const AndPill = styled(Box)(({ theme }) => ({
  fontSize: 10,
  fontWeight: 700,
  letterSpacing: 0.8,
  borderRadius: 10,
  padding: "2px 8px",
  background: `${theme.palette.primary.main}2e`,
  color: theme.palette.primary.dark,
}));

export const OrPill = styled(Box)(({ theme }) => ({
  fontSize: 10,
  fontWeight: 700,
  letterSpacing: 0.8,
  borderRadius: 10,
  padding: "3px 11px",
  background: theme.palette.warning.light,
  color: theme.palette.warning.dark,
}));

export const OrBar = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: 12,
  margin: "14px 0",
});

export const Rule = styled(Box)(({ theme }) => ({
  flex: 1,
  height: 1,
  background: theme.palette.divider,
}));

export const NarrowBox = styled(Box)(({ theme }) => ({
  paddingLeft: 14,
  borderLeft: `2px solid ${theme.palette.primary.main}3d`,
}));
